import { render, staticRenderFns } from "./PerfCharts.vue?vue&type=template&id=40923a2a&"
import script from "./PerfCharts.vue?vue&type=script&lang=js&"
export * from "./PerfCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports